import React from "react";
import { FaCheckCircle, FaClock, FaDumbbell, FaTrash } from "react-icons/fa";

import {
  buildResultKey,
  formatDateFr,
  getAdherentName,
  toBoolean,
} from "../utils/preparationPhysiqueUtils";

function AssignedExercisesPanel({ results, deletingKeys = [], onDelete }) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20 sm:p-6">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-emerald-600 dark:text-emerald-200">
            Suivi coach
          </p>

          <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            Exercices attribués
          </h2>
        </div>

        <p className="text-sm font-medium text-slate-500 dark:text-white/50">
          {results.length} attribution{results.length > 1 ? "s" : ""}
        </p>
      </div>

      {results.length === 0 ? (
        <div className="mt-6 rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50 p-8 text-center dark:border-white/10 dark:bg-white/[0.03]">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-slate-500 shadow-sm dark:bg-white/10 dark:text-white/50">
            <FaDumbbell className="text-2xl" />
          </div>

          <p className="mt-4 text-sm font-bold text-slate-700 dark:text-white">
            Aucun exercice attribué.
          </p>

          <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
            Sélectionne un exercice puis attribue-le à un groupe ou à des
            judokas.
          </p>
        </div>
      ) : (
        <div className="mt-6 grid gap-3 lg:grid-cols-2">
          {results.map((result) => {
            const resultKey = buildResultKey(result);
            const isDeleting = deletingKeys.includes(resultKey);
            const done = toBoolean(result.is_done);
            const adherent = result.Adherent || result.adherent || {};
            const exercise = result.Exercice || result.exercise || {};

            return (
              <article
                key={resultKey}
                className="rounded-[1.75rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.04]"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <span
                        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-bold ${
                          done
                            ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200"
                            : "bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200"
                        }`}
                      >
                        {done ? <FaCheckCircle /> : <FaClock />}
                        {done ? "Réalisé" : "À faire"}
                      </span>

                      <span className="rounded-full bg-white px-3 py-1 text-xs font-bold text-slate-500 shadow-sm dark:bg-white/10 dark:text-white/50">
                        {formatDateFr(result.date_realisation)}
                      </span>
                    </div>

                    <h3 className="mt-3 font-titre text-xl font-bold text-slate-950 dark:text-white">
                      {exercise.nom || "Exercice"}
                    </h3>

                    <p className="mt-1 text-sm font-bold text-slate-700 dark:text-white/80">
                      {getAdherentName(adherent)}
                    </p>

                    <p className="mt-2 text-xs font-medium leading-5 text-slate-500 dark:text-white/50">
                      Objectif :{" "}
                      {result.repetitions
                        ? `${result.repetitions} répétition(s)`
                        : exercise.programme || "Non renseigné"}
                    </p>
                  </div>

                  <button
                    type="button"
                    onClick={() => onDelete(result)}
                    disabled={isDeleting}
                    className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-red-600 text-white transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
                    aria-label="Supprimer l'attribution"
                  >
                    <FaTrash />
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default AssignedExercisesPanel;